import { RootState } from "../../../store/types";
import { connect } from "react-redux";
import ShiftTotalsSection from "./ShiftTotalsSection";

const mapStateToProps = (state: RootState) => ({
    shiftTotals: state.reviewAndPublish.shiftPlanOutput?.shiftTotals
});

export default connect(mapStateToProps)(ShiftTotalsSection);
